import { render, staticRenderFns } from "./qualificationForm2.vue?vue&type=template&id=64e34f1d&scoped=true&"
import script from "./qualificationForm2.vue?vue&type=script&lang=js&"
export * from "./qualificationForm2.vue?vue&type=script&lang=js&"
import style0 from "./qualificationForm2.vue?vue&type=style&index=0&id=64e34f1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e34f1d",
  null
  
)

export default component.exports